import React from "react";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { CSCQReducerNew, MSCQReducerNew } from "@learningblocks/exp-redux";
import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";

// Create Redux store for question components
const store = configureStore({
  reducer: {
    cscq: CSCQReducerNew,
    mscq: MSCQReducerNew,
    questionTable: QuestionTableReducer,
  },
});

interface ImageHotspotProvidersProps {
  children: React.ReactNode;
  locale: string;
  messages: Record<string, string>;
  usersnapProvider?: React.ComponentType<any>;
  usersnapProps?: any;
}

export function ImageHotspotProviders({
  children,
}: ImageHotspotProvidersProps): React.JSX.Element {
  const content = <Provider store={store}>{children}</Provider>;
  return content;
}

// Export types for convenience
export type { ImageHotspotProvidersProps };
